module.exports = __webpack_public_path__ + "img/text-decorate.09584672.png";